import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import 'normalize.css';

import Footer from '../components/Footer';
import CookiesTooltip from '../components/CookiesTooltip';

import './index.sass';

function Layout({ children }) {
  const { t } = useTranslation();

  return (
    <>
      {children}
      <Footer />
      <CookiesTooltip />
    </>
  );
}

export default Layout;